import {get} from 'svelte/store';
import {API_URLS} from '@/const/urls';
import {SERVICES} from '@/const/services';
import {http} from '@/helper/http';
import {lang$} from '@/store/lang';

export const web3Api = {
  getSoulPassOverview(query) {
    return http.get(API_URLS.WEB3_SOUL_PASS_OVERVIEW, {query});
  },
  getSoulPassStatus(query) {
    return http.get(API_URLS.WEB3_SOUL_PASS_STATUS, {query});
  },
  mint(params) {
    return http.post(API_URLS.WEB3_MINT, {params});
  },
  revoke(params) {
    return http.post(API_URLS.WEB3_REVOKE, {params});
  },
  createAddresses(params) {
    return http.post(API_URLS.WEB3_ADDRESSES_CREATE, {params});
  },
  bindAddresses(params) {
    return http.post(API_URLS.WEB3_ADDRESSES_BIND, {params});
  },
  unbindAddresses(params) {
    return http.post(API_URLS.WEB3_ADDRESSES_UNBIND, {params});
  },
  getMnemonic(params) {
    return http.post(API_URLS.WEB3_MNEMONIC, {params});
  },
  getAccountBizGray(query) {
    return http.get(API_URLS.ACCOUNT_BIZ_GRAY, {query});
  },
  getMintQualify(query) {
    return http.get(API_URLS.WEB3_SOUL_PASS_MINT_QUALIFY, {query});
  },
  getSbtList(query) {
    return http.get(API_URLS.WEB3_SBT_LIST, {query});
  },
  getWeb3Campaigns() {
    return http.get(API_URLS.ACTIVITY_CONTENTS_VIEW_LOGOUT, {
      query: {
        itemKey: 'banner',
        location: 11,
        lang: get(lang$),
      },
      formatter(data) {
        const {rows} = data;
        return rows.map((row) => ({
          ...row.detail,
          webimg: SERVICES.STATIC_URL + row.detail.webimg,
          appimg: SERVICES.STATIC_URL + row.detail.appimg,
        }));
      },
    });
  },
  getMoreSbtList() {
    return http.get(API_URLS.ACTIVITY_CONTENTS_VIEW_LOGOUT, {
      query: {
        itemKey: 'banner',
        location: 9,
        lang: get(lang$),
      },
      formatter(data) {
        const {rows = []} = data;
        return rows.map((row) => ({
          ...row.detail,
          name: row.detail.title,
          webimg: SERVICES.STATIC_URL + row.detail.webimg,
          appimg: SERVICES.STATIC_URL + row.detail.appimg,
          isMore: true,
        }));
      },
    });
  },
  getEthInfo(query) {
    return http.get(API_URLS.WEB3_100ETH_INFO, {query});
  },
  getEthUser(query) {
    return http.get(API_URLS.WEB3_100ETH_USER, {query});
  },
  getEthWinners(query) {
    return http.get(API_URLS.WEB3_100ETH_WINNERS, {query});
  },
  postWeb3Start(params) {
    return http.post(API_URLS.WEB3_GENERAL_START, {params});
  },
  walletLogin({query, params}) {
    return http.post(API_URLS.WEB3_WALLET_LOGIN, {query, params});
  },
  bindWallet(params) {
    return http.post(API_URLS.WEB3_BIND_WALLET, {params});
  },
  preBindEmail(params) {
    return http.post(API_URLS.WEB3_PRE_BIND_EMAIL, {params});
  },
  bindEmail(params) {
    return http.post(API_URLS.WEB3_BIND_EMAIL, {params});
  },
  getCryptos(query) {
    return http.get(API_URLS.WEB3_CRYPTO_LIST, {query});
  },
  getNfts(query) {
    return http.get(API_URLS.WEB3_NFT_LIST, {query});
  },
  getWeb3Info() {
    return http.get(API_URLS.WEB3_INFO, {});
  },
  getSupportChains() {
    return http.get(API_URLS.WEB3_SUPPORT_CHAINS, {});
  },
  get1000BtcGroup() {
    return http.get(API_URLS.WEB3_1000BTC_GROUP, {query: {activityKey: 'GUESS_BTC_PRICE', channel: 'WEB', scene: 'GUESS_PRICE'}});
  },
  get1000BtcGroupWithLogin() {
    return http.get(API_URLS.WEB3_1000BTC_GROUP_LOGIN, {});
  },
  get1000BtcList() {
    return http.get(API_URLS.WEB3_1000BTC_LIST, {query: {activityKey: 'GUESS_BTC_PRICE', channel: 'WEB', scene: 'GUESS_PRICE'}});
  },
  get1000BtcParticipant() {
    return http.get(API_URLS.WEB3_1000BTC_PARTICIPANT, {query: {activityKey: 'GUESS_BTC_PRICE', channel: 'WEB', scene: 'GUESS_PRICE'}});
  },
  get1000BtcPrice() {
    return http.get(API_URLS.WEB3_1000BTC_PRICE, {query: {activityKey: 'GUESS_BTC_PRICE', channel: 'WEB', scene: 'GUESS_PRICE'}});
  },
  vote1000Btc(params) {
    return http.post(API_URLS.WEB3_1000BTC_VOTE, {params: {activityKey: 'GUESS_BTC_PRICE', channel: 'WEB', scene: 'GUESS_PRICE', ...params}});
  },
  getDepositSupportNetworks(query) {
    return http.get(API_URLS.DEPOSIT_NETWORKS_LIST, {query});
  },
  getPreheatInfo() {
    return http.get(API_URLS.PT_PREHEAT_INFO, {query: {}});
  },
  signupForPreheatInfo() {
    return http.post(API_URLS.PT_PREHEAT_SIGN_UP, {});
  },
  getPreheatUserInfo() {
    return http.get(API_URLS.PT_PREHEAT_USER_INFO, {query: {}});
  },
  getStakeOverviewPublic(query) {
    return http.get(API_URLS.WEB3_STAKE_OVERVIEW_PUBLIC, {query});
  },
  getStakeOverview(query) {
    return http.get(API_URLS.WEB3_STAKE_OVERVIEW, {query});
  },
  getStakePublicDataProjects(query) {
    return http.get(API_URLS.WEB3_STAKE_PUBLIC_DATA_PROJECTS, {query});
  },
  postStakeRedeem(params) {
    return http.post(API_URLS.WEB3_STAKE_REDEEM, {params});
  },
  postStakeStake(params) {
    return http.post(API_URLS.WEB3_STAKE_STAKE, {params});
  },
  postStakeRewardsClaim(params) {
    return http.post(API_URLS.WEB3_STAKE_REWARDS_CLAIM, {params});
  },
  postStakeRewardsAutoCompound(params) {
    return http.post(API_URLS.WEB3_STAKE_REWARDS_AUTO_COMPOUND, {params});
  },
  getStakeVestingPlan(query) {
    return http.get(API_URLS.WEB3_STAKE_VESTING_PLAN, {query});
  },
  getStakeVestingPlanDetail(query) {
    return http.get(API_URLS.WEB3_STAKE_VESTING_PLAN_DETAIL, {query});
  },
  getStakeRedeemHistory(query) {
    return http.get(API_URLS.WEB3_STAKE_REDEEM_HISTORY, {query});
  },
  getStakeStakeHistory(query) {
    return http.get(API_URLS.WEB3_STAKE_STAKE_HISTORY, {query});
  },
  getStakeRewardsClaimHistory(query) {
    return http.get(API_URLS.WEB3_STAKE_REWARDS_CLAIM_HISTORY, {query});
  },
  getStakeBuybackHistory(query) {
    return http.get(API_URLS.WEB3_STAKE_BUYBACK_HISTORY, {query});
  },
  getStakeBurnMonth(query) {
    return http.get(API_URLS.WEB3_STAKE_BURN_MONTH, {query});
  },
  getStakeBurnDetail(query) {
    return http.get(API_URLS.WEB3_STAKE_BURN_DETAIL, {query});
  },
  getStakeBurnStats(query) {
    return http.get(API_URLS.WEB3_STAKE_BURN_STATS, {query});
  },
  getStakeRewardsAprHistory(query) {
    return http.get(API_URLS.WEB3_STAKE_REWARDS_APR_HISTORY, {query});
  },
  getPtMiningUserConfig(query) {
    return http.get(API_URLS.WEB3_PT_MINING_MINING_USER, {query});
  },
  getPtMiningAwardHistoryRecord(query) {
    return http.get(API_URLS.WEB3_PT_MINING_AWARD_RECORD, {query});
  },
  getPtMiningAwardBoost(query) {
    return http.get(API_URLS.WEB3_PT_MINING_AWARD_BOOST, {query});
  },
  /**
   * 1-线性发放；2-AutoStake
   * @param {{ptAwardType: 1 | 2}} params
   * @returns
   */
  putPtMiningAwardType(params) {
    return http.put(API_URLS.WEB3_PT_MINING_AWARD_TYPE_UPDATE, {params});
  },
  // 用户vePT信息查询
  getAccountVipLevelConfig(query) {
    return http.get(API_URLS.ACCOUNT_VIP_LEVEL_CONFIG, {query});
  },
  getSystemTime(query) {
    return http.get(API_URLS.SYSTEM_TIME, {query});
  },
  getAuctionProjectsPt(query) {
    return http.get(API_URLS.AUCTION_PROJECTS_PT, {query});
  },
  getAuctionBalance(query) {
    return http.get(API_URLS.AUCTION_BALANCE, {query});
  },
  postAuctionRedeem(params) {
    return http.post(API_URLS.AUCTION_REDEEM, {params});
  },
  postAuctionCommit(params) {
    return http.post(API_URLS.AUCTION_COMMIT, {params});
  },
  getSocialGroupBoard(query) {
    return http.get(API_URLS.SOCIAL_GROUP_BOARD, {query});
  },
  proShareInfo(query) {
    return http.post(API_URLS.SOCIAL_SHARE_INFO, {query});
  },
  profileEdit(params) {
    return http.post(API_URLS.SOCIAL_PROFILE_EDIT, {params});
  },
  groupProfileEdit(params) {
    return http.post(API_URLS.SOCIAL_GROUP_EDIT, {params});
  },
  groupTagEdit(params) {
    return http.post(API_URLS.SOCIAL_GROUP_TAG_EDIT, {params});
  },
  getProfileQuery(query) {
    return http.get(API_URLS.SOCIAL_PROFILE_QUERY, {query});
  },
  getWeekStatistic(query) {
    return http.get(API_URLS.SOCIAL_WEEK_STATISTIC, {query});
  },
  getWeekScore(query) {
    return http.get(API_URLS.SOCIAL_WEEK_SCORE, {query});
  },
  getRewardPool(query = {}) {
    return http.get(API_URLS.SOCIAL_REWARD_POOL, {query});
  },
  getGroupList(query) {
    return http.get(API_URLS.SOCIAL_GROUP_LIST, {query});
  },
  timePassOpen(params) {
    return http.post(API_URLS.SOCIAL_TIME_PASS_OPEN, {params});
  },
  getTimePassOpen(query) {
    return http.get(API_URLS.SOCIAL_TIME_PASS_IS_OPEN, {query});
  },

  getSocialTradePrizePool() {
    return http.get(API_URLS.WEB3_SOCIAL_PRIZE_POOL, {query: {}});
  },
  getSocialTradeGroups(pageNum, pageSize, {orderBy, groupName}) {
    orderBy = orderBy || undefined;
    groupName = groupName || undefined;
    return http.get(API_URLS.WEB3_SOCIAL_TRADE_GROUPS, {query: {pageNum, pageSize, orderBy, groupName}});
  },
  getSocialTradeGroupsWhileLogin(pageNum, pageSize, {orderBy, groupName}) {
    orderBy = orderBy || undefined;
    groupName = groupName || undefined;
    return http.get(API_URLS.WEB3_SOCIAL_TRADE_GROUPS_LOGIN, {query: {pageNum, pageSize, orderBy, groupName}});
  },
  getUserSocialTradeInfo() {
    return http.get(API_URLS.WEB3_SOCIAL_MY_INFO, {query: {}});
  },
  getSocialTradeGroupLeaderBoard(groupId, weekStartTs) {
    return http.get(API_URLS.WEB3_SOCIAL_TRADE_GROUP_LEADER_BOARD, {query: {groupId, weekStartTs}});
  },
  getSocialTradeGroupLeaderBoardWhileLogin(groupId, weekStartTs) {
    return http.get(API_URLS.WEB3_SOCIAL_TRADE_GROUP_LEADER_BOARD_LOGIN, {query: {groupId, weekStartTs}});
  },
  getUserRelatedGroups() {
    return http.get(API_URLS.WEB3_SOCIAL_MY_TRADE_GROUPS, {query: {}});
  },
  createSocialTradeGroup(code, verifier, redirectUri) {
    return http.post(API_URLS.WEB3_SOCIAL_CREATE_GROUP, {params: {code, verifier, redirectUri}});
  },
  joinSocialTradeGroup(groupId, source) {
    return http.post(API_URLS.WEB3_SOCIAL_JOIN_GROUP, {query: {groupId, source}});
  },
  joinSocialTradeGroupByReferralCode(referralCode) {
    return http.post(API_URLS.WEB3_SOCIAL_INVITE_JOIN_GROUP_WITH_REFERRAL_CODE, {query: {referralCode}});
  },
  inviteJoinSocialTradeGroup(groupId, source, memberId) {
    return http.post(API_URLS.WEB3_SOCIAL_INVITE_JOIN_GROUP, {query: {groupId, source, memberId}});
  },
  getGroupInfoWithEnGroupId(enGroupId) {
    return http.get(API_URLS.WEB3_SOCIAL_GROUP_INFO_WITH_EN_GROUP, {query: {enGroupId}});
  },
  getGroupInfoWithGroupId(groupId) {
    return http.get(API_URLS.WEB3_SOCIAL_GROUP_INFO, {query: {groupId}});
  },
  getGroupInfoWithGroupIdWhileLogin(groupId) {
    return http.get(API_URLS.WEB3_SOCIAL_GROUP_INFO_LOGIN, {query: {groupId}});
  },
  mintGroupPass(params) {
    return http.post(API_URLS.SOCIAL_GROUP_PASS_MINT, {params});
  },
  deployGroupPass(params) {
    return http.post(API_URLS.SOCIAL_GROUP_PASS_DEPLOY, {params});
  },
  getDeployGroupPass(query) {
    return http.get(API_URLS.SOCIAL_GROUP_PASS_DEPLOY_DETAIL, {query});
  },
  getPassGroupList(query, login) {
    return http.get(login ? API_URLS.SOCIAL_GROUP_PASS_GROUP_LIST : API_URLS.SOCIAL_GROUP_PASS_GROUP_LIST_PUBLIC, {query});
  },
  getGroupPassGroup(query) {
    return http.get(API_URLS.SOCIAL_GROUP_PASS_GROUP, {query});
  },
  getOrderBookList(query) {
    return http.get(API_URLS.SOCIAL_GROUP_PASS_ORDER_BOOK_LIST, {query});
  },
  getOrderBookKLine(query) {
    return http.get(API_URLS.SOCIAL_GROUP_PASS_ORDER_BOOK_LIST_K, {query});
  },
  getAccountList(query) {
    return http.get(API_URLS.SOCIAL_GROUP_PASS_MY_GROUP_AVAILABLE, {query});
  },
  getOrderList(query) {
    return http.get(API_URLS.SOCIAL_GROUP_PASS_MY_GROUP_ORDER_BOOK_LIST, {query});
  },
  pendingOrder(params) {
    return http.post(API_URLS.SOCIAL_GROUP_PASS_PENDING_ORDER, {params});
  },
  cancelList(params) {
    return http.post(API_URLS.SOCIAL_GROUP_PASS_CANCEL_LIST, {params});
  },
  buyGroupPass(params) {
    return http.post(API_URLS.SOCIAL_GROUP_PASS_BUY, {params});
  },
  joinGroup(query) {
    return http.post(API_URLS.WEB3_SOCIAL_JOIN_GROUP, {query});
  },
  mintInquiry(query) {
    return http.get(API_URLS.SOCIAL_GROUP_PASS_MINT_INQUIRY, {query});
  },
  groupPassConfig(query) {
    return http.get(API_URLS.SOCIAL_GROUP_PASS_CONFIG, {query});
  },
  groupModeratorConfig(query) {
    return http.get(API_URLS.SOCIAL_MODERATOR_CONFIG, {query});
  },
  groupModeratorApply(params) {
    return http.post(API_URLS.SOCIAL_MODERATOR_APPLY, {params});
  },
  groupModeratorInfo(query) {
    return http.get(API_URLS.SOCIAL_MODERATOR_INFO, {query});
  },
  getPulseDropConfig(query) {
    return http.get(API_URLS.SOCIAL_PULSE_DROP_CONFIG, {query});
  },
  getPulseDropTasks(query) {
    return http.get(API_URLS.SOCIAL_PULSE_DROP_TASK, {query});
  },
  addPulseDropTask(query) {
    return http.post(API_URLS.SOCIAL_PULSE_DROP_TASK_ADD, {query});
  },
  updateProfilePio(params) {
    return http.post(API_URLS.SOCIAL_USER_PROFILE_UPDATE, {params});
  },
  getDataVolume() {
    return http.post(API_URLS.WEB3_SOCIAL_TRADE_DATA_VOLUME, {});
  },
};
